<template>
    <div class="badgebox-success">
        <Badgebox :key="data.key">
            <p
                v-bastards
                class="fs-21 fs-lh-28 text-bold text-center"
            >
                Dziękujemy, informacja jak odebrać wybrany produkt zostanie przesłana na Twój adres e-mail.
            </p>

            <p class="fs-21 fs-lh-28 text-bold text-center"
               style="margin-top: 21px; width: 100%;">
                Posługujesz się nowym adresem? 
                <a 
                    class="btn btn-c--primary btn-s--large text-bold-medium text-upper" 
                    style="width: auto; padding: 10px 35px; margin-left: 20px;"
                    href="/email"
                >
                    Uaktualnij adres e-mail
                </a>
            </p>
        </Badgebox>
    </div>
</template>

<script>
import Badgebox from '@/components/badgebox/Badgebox'

export default {
    components: {
        Badgebox
    },

    props: {
        data: {
            type: Object,
            required: false,
            default: () => {}
        }
    }
}
</script>

<style>

</style>
